import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HistoryEventsView from './HistoryEventsView';
import {
  getDeviceDocumentById,
  downloadDeviceDocument,
  clearDeviceDocument,
  clearDocumentFilter,
} from '../../actions/documents';

const PAGE_SIZE = 1000;

class HistoryEvents extends React.Component {
  getFilter = deviceDocument => {
    let filter = {};
    switch (deviceDocument.get('deviceType')) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        filter = this.props.documentSoftenerFilter;
        break;
      case 'superior':
        filter = this.props.documentSuperiorFilter;
        break;
      default:
        break;
    }
    return filter;
  };

  getNextPage = () => {
    this.props.getDeviceDocumentById(
      this.props.deviceDocument.get('serial'),
      this.props.deviceDocument.get('documentName'),
      {},
      +this.props.deviceDocumentPaging.get('currentPage') + 1,
      PAGE_SIZE,
    );
  };

  componentWillMount() {
    const deviceDocument = this.props.deviceDocument;
    if (
      typeof deviceDocument !== 'undefined' &&
      deviceDocument.get('serial') !== null
    ) {
      this.props.getDeviceDocumentById(
        deviceDocument.get('serial'),
        deviceDocument.get('documentName'),
        {},
        1,
        PAGE_SIZE,
      );
    }
  }

  componentWillUpdate(newProps) {
    const isUpdatedDocument =
      newProps.deviceDocument.get('serial') !==
      this.props.deviceDocument.get('serial');
    if (isUpdatedDocument && 
      newProps.deviceDocument.get('serial') !== null &&
      +newProps.deviceDocument.get('documentType') === 1) {
      this.props.getDeviceDocumentById(
        newProps.deviceDocument.get('serial'),
        newProps.deviceDocument.get('documentName'),
        {},
        +this.props.deviceDocumentPaging.get('currentPage'),
        PAGE_SIZE,
      );
    }
    return true;
  }

  componentWillUnmount() {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDeviceDocument();
    this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
  }

  onSavePDF = (events, web) => {
    const { deviceDocument, deviceDocumentPaging } = this.props;
    const filter = this.getFilter(deviceDocument);
    if (web) {
      this.props.downloadDeviceDocument(
        deviceDocument.get('serial'),
        deviceDocument.get('documentName'),
        JSON.stringify(filter),
        events,
        deviceDocumentPaging.get('currentPage'),
        deviceDocumentPaging.get('itemsPerPage'),
      );
    } else {
      this.props.downloadDeviceDocument(
        deviceDocument.get('serial'),
        deviceDocument.get('documentName'),
        JSON.stringify(filter),
        events,
      );
    }

  };

  onClearFilter = () => {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDocumentFilter(
      'events',
      deviceDocument.get('deviceType'),
    )
  };

  closePopup = () => {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDeviceDocument();
    this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
  };

  render() {
    return (
      <HistoryEventsView
        documentRows={this.props.documentRows}
        deviceDocument={this.props.deviceDocument}
        deviceDocumentPaging={this.props.deviceDocumentPaging}
        documentSoftenerFilter={this.props.documentSoftenerFilter}
        documentSuperiorFilter={this.props.documentSuperiorFilter}
        getNextPage={this.getNextPage}
        onClose={this.closePopup}
        onSavePDF={this.onSavePDF}
        onClearFilter={this.onClearFilter}
      />
    );
  }
}

const mapState = state => ({
  deviceDocument: state.deviceDocument,
  documentRows: state.documentRows,
  deviceDocumentPaging: state.deviceDocumentPaging,
  documentSoftenerFilter: state.softenerEventFilter,
  documentSuperiorFilter: state.superiorEventFilter,
});

const mapDispatch = dispatch => {
  return {
    getDeviceDocumentById: (serial, documentId, filterData, page, pageSize) =>
      dispatch(
        getDeviceDocumentById(serial, documentId, filterData, page, pageSize)
      ),
    clearDeviceDocument: () => dispatch(clearDeviceDocument()),
    downloadDeviceDocument: (serial, documentId, filterData, events, page, pageSize) => 
      dispatch(
        downloadDeviceDocument(serial, documentId, filterData, events, page, pageSize)
      ),
    clearDocumentFilter: (deviceType, documentType) => 
      dispatch(clearDocumentFilter(deviceType, documentType)),
  };
};

HistoryEvents.propTypes = {
  getDeviceDocumentById: PropTypes.func.isRequired,
  clearDeviceDocument: PropTypes.func.isRequired,
  clearDocumentFilter: PropTypes.func.isRequired,
  downloadDeviceDocument: PropTypes.func.isRequired,
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentRows: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default connect(mapState, mapDispatch)(HistoryEvents);


// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEvents.js